import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { NextPageWithLayout } from './_app';
import Layout from 'components/Layout';
import TextPage from 'components/TextPage';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';
import { GetServerSideProps } from 'next';

interface IJobsProps {
  content: string | null;
  frontmatter: { title: string };
}

const Jobs: NextPageWithLayout<IJobsProps> = ({
  frontmatter: { title },
  content,
}) => {
  return <TextPage title={title} content={content} />;
};

Jobs.getLayout = (page: React.ReactElement) => (
  <Layout
    navBarClassName="bg-white py-6"
    titleProduction="meta_title_jobs"
    titleStaging="Jobs"
    metaDescriptionProd="meta_description_production_jobs"
    metaDescriptionStaging="Allmyles API developer jobs - we are hiring"
    canonicalProd="https://tipptour.com/jobs"
    canonicalStaging="https://showcase.allmyles.com/jobs">
    {page}
  </Layout>
);
export default Jobs;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const env = process.env.NEXTJS_NODE_ENV === 'production' ? 'prod' : 'dev';
  try {
    const markdownWithMeta = fs.readFileSync(
      path.join(process.cwd(), `assets/localization/jobs/${env}/${locale}.md`),
    );
    const { data: frontmatter, content } = matter(markdownWithMeta);
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: JSON.parse(JSON.stringify(frontmatter)),
        content: content,
      } as IJobsProps,
    };
  } catch (err) {
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: { title: '' },
        content: null,
      } as IJobsProps,
    };
  }
};
